import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivate,
} from '@angular/router';
import { UAMAuthService } from '../services/uam-auth.service';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(
    private uamService: UAMAuthService,
  ) { };
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): any {
    const userDetails: any = this.uamService.getAuthenticatedUser();
    if (userDetails && (['pavcon'].includes(userDetails['custom:emirld_role']))) {
      return true;
    } else {
      // this.router.navigate(['/home']);
      window.location.href = environment.uamUrl;
      return false;
    }
  }
}
